import React from 'react'

// utils
import { formatPrice } from '../../utils/helper'

// types
import { Price } from '../../types/types'

// styles
import * as SC from './RenderPriceStyles'

type Props = {
	from?: Price | null
	to?: Price | null
	fromSecondary?: Price | null
	toSecondary?: Price | null
	className?: string
}

const RenderPrice = (props: Props): React.ReactNode => {
	const { from, to, fromSecondary, toSecondary, className } = props
	const formattedPrice = formatPrice({ from, to, fromSecondary, toSecondary })

	if (!formattedPrice) {
		return null
	}

	return <SC.RenderPriceContainer className={className}>{formattedPrice}</SC.RenderPriceContainer>
}

export default RenderPrice
